// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__1e9Sj","datetime":"Title_datetime__i3aB1","arrows":"Title_arrows__1tfZg"};